import { ActionTree } from "vuex";
import { RecoveryState } from "./state";

export const actions: ActionTree<RecoveryState, any> = {
  async searchUsers({ commit }, query: string) {
    commit("SET_IS_SEARCHING", true);
    try {
      const apiUrl = process.env.VUE_APP_API_URL || "http://localhost:8000/api";
      const token = localStorage.getItem("token");

      const response = await fetch(
        `${apiUrl}/admin/support-recovery/users/search?q=${encodeURIComponent(query)}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const responseData = await response.json();
      if (!response.ok) throw new Error(responseData.message || "Search failed");

      commit("SET_SEARCH_RESULTS", responseData.data);
    } catch (error) {
      console.error(error);
    } finally {
      commit("SET_IS_SEARCHING", false);
    }
  },

  async fetchAuditLogs({ commit }) {
    try {
      const apiUrl = process.env.VUE_APP_API_URL || "http://localhost:8000/api";
      const token = localStorage.getItem("token");

      const response = await fetch(`${apiUrl}/admin/support-recovery/audit-logs`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const responseData = await response.json();
      if (responseData.success) {
        // paginatedResponse returns data directly as an array
        commit("SET_AUDIT_LOGS", responseData.data || []);
      }
    } catch (error) {
      console.error(error);
    }
  },

  async fetchStatistics() {
    try {
      const apiUrl = process.env.VUE_APP_API_URL || "http://localhost:8000/api";
      const token = localStorage.getItem("token");

      const response = await fetch(`${apiUrl}/admin/support-recovery/stats`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const responseData = await response.json();
      if (responseData.success) {
        return responseData.data;
      }
    } catch (error) {
      console.error(error);
    }
    return null;
  },

  async performRecoveryAction({ dispatch }, { userId, method, reason }) {
    try {
      const apiUrl = process.env.VUE_APP_API_URL || "http://localhost:8000/api";
      const token = localStorage.getItem("token");

      const response = await fetch(`${apiUrl}/admin/support-recovery/perform-action`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: userId,
          send_method: method,
          reason: reason || `Manual recovery via support panel (${method})`,
        }),
      });

      const responseData = await response.json();
      if (!response.ok) throw new Error(responseData.message || "Failed to register action");

      await dispatch("fetchAuditLogs");
      return responseData.data; // Return the link and other info
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};
